<template>
  <!-- <div id="Countdown">{{ time }}</div> -->
  <div id="bar">
    <div id="top" :style="{ width: width + '%' }"></div>
  </div>
  <div class="start button" v-if="!started" @click="start">START</div>
  <div class="start button" v-if="restartAvailable" @click="restart">
    RESTART
  </div>
</template>

<script>
export default {
  name: "Countdown",
  components: {},
  emits: ["finish", "start"],
  props: {
    seconds: {
      type: Number,
      default: () => 30,
    },
  },
  data() {
    return {
      totalTime: this.seconds * 100,
      usedTime: 0,
      startTime: 0,
      timer: null,
      time: "00:" + this.seconds + ".00",
      width: 100,
      factor: 1000 / this.seconds,
      started: false,
      restartAvailable: false,
    };
  },

  methods: {
    count() {
      this.usedTime = Math.floor((+new Date() - this.startTime) / 10);

      var tt = this.totalTime - this.usedTime;
      // console.log(tt);
      if (tt <= 0) {
        this.time = "00:00.00";
        this.finish();
        clearInterval(this.timer);
      } else {
        var mi = Math.floor(tt / (60 * 100));
        var ss = Math.floor((tt - mi * 60 * 100) / 100);
        var ms = tt - Math.floor(tt / 100) * 100;

        this.time =
          this.fillZero(mi) + ":" + this.fillZero(ss) + "." + this.fillZero(ms);
        this.width = (tt / 1000) * this.factor;
        // console.log(this.width);
      }
    },
    finish() {
      this.width = 0;
      this.restartAvailable = true;
      this.$emit("finish", true);
    },
    // init() {
    //   if (this.timer) {
    //     clearInterval(this.timer);
    //     this.time = "00:00.00";
    //     this.totalTime = this.seconds * 100;
    //     this.usedTime = 0;
    //     this.startTime = +new Date();
    //     this.timer = null;
    //   }
    // },
    start() {
      this.restartAvailable = false;
      this.started = true;
      if (!this.timer) {
        this.startTime = +new Date();
        this.timer = setInterval(this.count, 1);
      }
      this.$emit("start", true);
    },
    restart() {
      this.totalTime = this.seconds * 100;
      this.usedTime = 0;
      this.startTime = 0;
      this.timer = null;
      this.time = "00=" + this.seconds + ".00";
      this.width = 100;
      this.factor = 1000 / this.seconds;

      this.start();
    },
    stop() {
      console.log("usedTime = " + this.usedTime);
      if (this.timer) clearInterval(this.timer);
    },
    fillZero(num) {
      return num < 10 ? "0" + num : num;
    },
  },
  created() {
    // this.init();
  },
};
</script>

<style scoped>
.start:hover {
  cursor: pointer;
  background: black;
  color: white;
}

.start {
  margin: 10px auto;
  border: 2px solid black;
  width: 100px;
  border-radius: 10px;
}

#Countdown {
  font-size: 70px;
  margin-top: 80px;
}

#bar {
  border: 1px solid;
  width: 500px;
  height: 20px;
  margin: 0 auto;
}

#top {
  height: 100%;
  background: red;
}
</style>
